/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Jayati_Quote_P2Inputs */

const en_marketing_app_jayati_quote_p2 = /** @type {(inputs: Marketing_App_Jayati_Quote_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` is just so convenient and amazing`)
};

const es_marketing_app_jayati_quote_p2 = /** @type {(inputs: Marketing_App_Jayati_Quote_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` es simplemente muy conveniente e increíble`)
};

/**
* | output |
* | --- |
* | "is just so convenient and amazing" |
*
* @param {Marketing_App_Jayati_Quote_P2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_jayati_quote_p2 = /** @type {((inputs?: Marketing_App_Jayati_Quote_P2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Jayati_Quote_P2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_jayati_quote_p2(inputs)
	return en_marketing_app_jayati_quote_p2(inputs)
});